import request from '@/utils/request'
// 嘉宾接口

export function getPersonInfo (query) {
    return request({
        url: 'conference-guest/info',
        method: 'get',
        params: query
    })
}

export function getLocationInfo (query) {
    return request({
        url: 'conference-guest/notcheck/location',
        method: 'get',
        params: query
    })
}

export function getLocationInfoPhone(query) {
  return request({
    url: "conference-guest/notcheck/location/phone",
    method: "get",
    params: query,
  });
}

export function getLocationInfoEmail(query) {
  return request({
    url: "conference-guest/notcheck/location/email",
    method: "get",
    params: query,
  });
}

export function getArrivalInfo (query) {
    return request({
        url: 'conference-guest/arrival',
        method: 'get',
        params: query
    })
}

export function getLeaveInfo (query) {
    return request({
        url: 'conference-guest/leave',
        method: 'get',
        params: query
    })
}

export function getAccommodationInfo (query) {
    return request({
        url: 'conference-guest/accommodation',
        method: 'get',
        params: query
    })
}

export function submitInfo (data) {
    return request({
        url: 'conference-guest/confirm',
        method: 'post',
        data
    })
}

export function updateActivity (data) {
    return request({
        url: 'conference-guest/activity',
        method: 'put',
        data
    })
}

export function updateArrival (data) {
    return request({
        url: 'conference-guest/arrival',
        method: 'put',
        data
    })
}

export function updateLeave (data) {
    return request({
        url: 'conference-guest/leave',
        method: 'put',
        data
    })
}

export function updateAccommodate (data) {
    return request({
        url: 'conference-guest/accommodation',
        method: 'put',
        data
    })
}

export function updateStatement (data) {
    return request({
        url: 'conference-guest/statement',
        method: 'put',
        data
    })
}

export function updateBaseInfo(data) {
  return request({
    url: "conference-guest/baseInfo",
    method: "put",
    data,
  });
}

export function updateAttend(data) {
  return request({
    url: "conference-guest/attend",
    method: "put",
    data,
  });
}

export function confirmInfo(data) {
  return request({
    url: "conference-guest/onlyConfirm",
    method: "post",
    data,
  });
}
